import AdminTabs from '../AdminTabs';
import { useAdminSubTab } from '../adminRoute';
import LoyaltyPointsPanel from './LoyaltyPointsPanel';
import MembersPanel from './MembersPanel';
import BorrowSettingsPanel from './BorrowSettingsPanel';
import DispensingSettingsPanel from './DispensingSettingsPanel';

/**
 * Admin Panel → 💊 Pharmacy.
 *
 * ── Why the MODULE is the tab and the feature is inside it ──
 *
 * The top-level tab is named for the part of the hospital it configures, not
 * for the one feature that happens to live there today. Loyalty points are a
 * pharmacy feature — every rule inside is stated in pharmacy terms, and the
 * earning basis is a *pharmacy bill's* subtotal — so they belong under
 * Pharmacy rather than sitting at the top level as if they were their own
 * department.
 *
 * That also leaves the obvious room: anything else the pharmacy needs
 * configured centrally (dispensing defaults, stock thresholds, a schedule
 * register policy) becomes another sub-tab here instead of another entry in an
 * admin bar that is already fifteen tabs long.
 *
 * The module grant behind this tab is still `admin:pharmacy-loyalty` — the
 * label changed, the permission did not. Renaming the grant would mean a
 * migration and would silently revoke access for every role that already holds
 * it, which is a real cost for a cosmetic gain.
 */
export default function PharmacyTab() {
  const tabs = useAdminSubTab('pharmacy-policies');
  const tab = tabs.active;

  return (
    <div className="fade-in">
      <AdminTabs state={tabs} />

      {tab === 'loyalty' && <LoyaltyPointsPanel />}
      {tab === 'members' && <MembersPanel />}
      {tab === 'borrow' && <BorrowSettingsPanel />}
      {tab === 'dispensing' && <DispensingSettingsPanel />}
    </div>
  );
}
